import React from "react";

export default ({m}) => (
  <div className="confirmation-calendar-header">
    <div className="confirmation-calendar-header-title">{m.format('MMMM')}</div>
    <div className="confirmation-calendar-header-year">{m.format('Y')}</div>
    <div className="confirmation-calendar-header-months">Sun</div>
    <div className="confirmation-calendar-header-months">Mon</div>
    <div className="confirmation-calendar-header-months">Tue</div>
    <div className="confirmation-calendar-header-months">Wed</div>
    <div className="confirmation-calendar-header-months">Thu</div>
    <div className="confirmation-calendar-header-months">Fri</div>
    <div className="confirmation-calendar-header-months">Sat</div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/common/calendar/monthHeaderView.js